<template>
    <div class='list'>
        <div class="toolbar">
            <div class="toolbar-left">
                <div class="toolbar-title">
                    <i class="el-icon-user"></i>
                    <span>用户统计面板</span>
                </div>
                <p class="toolbar-subtitle">按日期查看点赞、邮件、收益等关键指标</p>
            </div>
            <div class="toolbar-filters">
                <el-input prefix-icon="el-icon-search" class="filter-input" v-model.trim="query" clearable
                    placeholder="搜索昵称、账号或所属账号"></el-input>
                <el-date-picker class="filter-datepicker" v-model="selectedDate" type="date" placeholder="选择日期"
                    value-format="yyyy-MM-dd" :clearable="false" @change="handleDateChange">
                </el-date-picker>
                <el-button class="filter-reset" type="text" icon="el-icon-refresh-left" @click="resetFilters">重置</el-button>
            </div>
        </div>
        <el-table border :data="filteredTableData" style="width: 100%" @selection-change="handleSelectionChange"
            v-loading="loading">
            <el-table-column type="selection" width="55" align="center"></el-table-column>

            <el-table-column type="index" width="55" align="center">
                <template slot="header" slot-scope="scope">
                    <div class="statusTitle">
                        <i class="el-icon-upload2" style="color: #666666;"></i>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="头像" width="90" align="center">
                <template #default="scope">
                    <div class="avatar-wrapper">
                        <img class="avatar-img" :src="scope.row.avatar || require('@/assets/profile.png')"
                            :alt="scope.row.nickName || 'avatar'" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="名字" align="center">
                <template slot-scope="scope">
                    <div style="color: #2499ff;">
                        {{ scope.row.mfUserDetail?.name || scope.row.nickName || '--' }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="platformUserId" label="个人资料ID" align="center">
            </el-table-column>
            <!-- <el-table-column prop="userAccount" label="电子邮件" align="center">
            </el-table-column>
            <el-table-column prop="userPassword" label="密码" align="center">
            </el-table-column> -->
            <el-table-column prop="address" align="center">
                <template slot="header" slot-scope="scope">
                    <div class="address">
                        <div>所属账号</div>
                        <!-- <img src="@/assets/fh.png" alt=""> -->
                    </div>
                </template>
                <template slot-scope="scope">
                    <div>{{ scope.row.sysUserName }}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="platformType" label="所属平台" align="center">
            </el-table-column> -->
<!--            <el-table-column prop="likeCount" label="点赞数" align="center">-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="followCount" label="关注数" align="center">-->
<!--            </el-table-column>-->
            <el-table-column prop="emailCount" label="newsfeed通过数量" align="center">
            </el-table-column>
            <el-table-column prop="icebreakerCount" label="Icebreaker数" align="center">
            </el-table-column>
            <el-table-column label="24小时发帖" align="center" width="110">
                <template #default="scope">
                    <div class="post-status-cell">
                        <el-tag :type="getIsNowSend(scope.row) ? 'success' : 'info'" effect="plain" size="mini">
                            {{ getIsNowSend(scope.row) ? '已发帖' : '未发帖' }}
                        </el-tag>
                        <div v-if="getFormattedSendTime(scope.row)" class="send-time-text">
                            {{ getFormattedSendTime(scope.row) }}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="revenue" label="收益" align="center">
                <template #default="scope">
                    {{ formatRevenue(scope.row.revenue) }}
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination :total="myTotal" pagination @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize">
            </el-pagination>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <div class="dialog_content">
                <div class="dialog_left">
                    <div class="left_title">验证个人资料</div>
                    <el-form ref="form" :model="form">
                        <el-form-item class="form_item">
                            <el-input v-model="form.site" placeholder="请选择站点" readonly></el-input>
                        </el-form-item>
                        <el-form-item class="form_item">
                            <el-input v-model="form.name" placeholder="登录账号"></el-input>
                        </el-form-item>
                        <el-form-item class="form_item">
                            <el-input v-model="form.password" placeholder="密码"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <div style="display: flex; justify-content: center; align-items: center;margin-top: 34px;">
                                <el-button type="primary" @click="onSubmit" class="submit">验证</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="dialog_right">
                    <div class="right_title">个人身份</div>
                    <div></div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import dayjs from 'dayjs'
import { getMyList, selectStatisticByUserAndDate } from '@/api/dialogue'
import { checkUser } from '@/api/user'

export default {
    components: {},
    data() {
        return {
            query: '',
            myTotal: 0,
            pageNumber: 1,
            pageSize: 10,
            dialogVisible: false, // 个人资料弹窗
            loading: false,
            selectedDate: dayjs().format('YYYY-MM-DD'),
            tableData: [
                {
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }
            ],
            form: {
                site: 'dating',
                name: '',
                password: ''
            }
        };
    },
    computed: {
        filteredTableData() {
            if (!this.query) {
                return this.tableData
            }
            const keyword = this.query.toLowerCase()
            return this.tableData.filter(item => {
                const name = (item.mfUserDetail?.name || item.nickName || '').toLowerCase()
                const account = (item.userAccount || '').toLowerCase()
                const sysUser = (item.sysUserName || '').toLowerCase()
                return name.includes(keyword) || account.includes(keyword) || sysUser.includes(keyword)
            })
        }
    },
    watch: {},
    methods: {
        getIsNowSend(row) {
            console.log('row::::::', row)
            const value = row?.isNowSend ?? row?.nowSend
            if (value === true || value === false) {
                return value
            }
            if (typeof value === 'string') {
                return value.toLowerCase() === 'true'
            }
            return Boolean(value)
        },
        getFormattedSendTime(row) {
            const raw = row?.sendTime || row?.lastPostTime || row?.postTime
            if (!raw) return ''
            const parsed = dayjs(raw)
            if (!parsed.isValid()) {
                return raw
            }
            return parsed.format('YYYY-MM-DD HH:mm')
        },
        getMyList() {
            this.loading = true
            const baseDate = this.selectedDate ? dayjs(this.selectedDate) : dayjs()
            const startDate = baseDate.hour(8).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss')
            const endDate = dayjs(startDate).add(24, 'hour').format('YYYY-MM-DD HH:mm:ss')
            selectStatisticByUserAndDate({
                pageSize: this.pageSize,
                pageNum: this.pageNumber,
                startDate,
                endDate
            }).then(res => {
                const list = res.data || res.rows || []
                this.tableData = list.map(item => ({
                    ...item,
                    mfUserDetail: item.mfUserDetail || { name: item.nickName || '' },
                    platformUserId: item.platformUserId || item.pdUserId || '',
                    userAccount: item.userAccount || item.pdUserAccount || '',
                    userPassword: item.userPassword || '',
                    platformType: item.platformType || '',
                }))
                this.myTotal = Number(res.total ?? this.tableData.length ?? 0)
            }).finally(() => {
                this.loading = false
            })
        },
        handleSelectionChange() { },
        onSubmit() {
            console.log('这里', this.form)
            checkUser({
                platformType: this.form.site,
                userAccount: this.form.name,
                userPassword: this.form.password
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.$message.success('验证成功，身份正确')
                    this.dialogVisible = false;
                } else {
                    this.$message.error('验证失败' + res.msg)
                }
            })
        },
        handleEdit(row) {
            console.log(row)
            this.form.name = row.userAccount;
            this.form.password = row.userPassword;
            this.dialogVisible = true;
        },
        handleSizeChange(val) {

        },
        handleCurrentChange(val) {
            this.pageNumber = val
            this.getMyList()
        },
        handleDateChange() {
            this.pageNumber = 1
            this.getMyList()
        },
        resetFilters() {
            this.query = ''
            this.selectedDate = dayjs().format('YYYY-MM-DD')
            this.pageNumber = 1
            this.getMyList()
        },
        formatRevenue(value) {
            if (value === null || value === undefined || value === '') {
                return '--'
            }
            const number = Number(value)
            if (Number.isNaN(number)) {
                return value
            }
            return number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    },
    created() {
        this.getMyList()
    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.list {
    margin-top: 28px;

    .toolbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 24px;
        margin-bottom: 24px;
        background: linear-gradient(135deg, #f6f9ff 0%, #ffffff 50%, #fef8ff 100%);
        border-radius: 16px;
        box-shadow: 0 10px 30px rgba(82, 123, 255, 0.08);
        border: 1px solid rgba(102, 132, 255, 0.12);

        .toolbar-left {
            display: flex;
            flex-direction: column;
            gap: 6px;

            .toolbar-title {
                display: flex;
                align-items: center;
                gap: 10px;
                font-weight: 600;
                font-size: 20px;
                color: #233559;

                i {
                    font-size: 22px;
                    color: #5d7cff;
                    background: rgba(93, 124, 255, 0.14);
                    padding: 8px;
                    border-radius: 12px;
                }
            }

            .toolbar-subtitle {
                margin: 0;
                font-size: 13px;
                color: #6d7a8f;
                letter-spacing: 0.2px;
            }
        }

        .toolbar-filters {
            display: flex;
            align-items: center;
            gap: 12px;

            .filter-input {
                width: 320px;

                ::v-deep .el-input__inner {
                    border-radius: 10px;
                    border-color: rgba(121, 134, 203, 0.35);
                    box-shadow: inset 0 1px 2px rgba(121, 134, 203, 0.12);
                    transition: all 0.2s ease;

                    &:focus {
                        border-color: #6b77ff;
                        box-shadow: 0 0 0 3px rgba(107, 119, 255, 0.16);
                    }
                }

                ::v-deep .el-icon-search:before {
                    font-size: 16px;
                    color: #6b77ff;
                }
            }

            .filter-datepicker {
                width: 180px;

                ::v-deep .el-input__inner {
                    border-radius: 10px;
                    border-color: rgba(121, 134, 203, 0.35);
                    text-align: center;
                    font-size: 14px;
                }
            }

            .filter-reset {
                color: #6b77ff;
                font-weight: 500;
            }
        }
    }
}

    .avatar-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 44px;
        height: 44px;
        margin: 0 auto;
    }

    .avatar-img {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        object-fit: cover;
        border: 1px solid #eee;
    }

.pagination {
    width: 30%;
    margin-left: auto;
    margin-top: 20px;
}

.statusTitle {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .img {
        width: 12px;
        height: 8px;
    }
}

.post-status-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.send-time-text {
    font-size: 12px;
    color: #67728a;
    background: rgba(103, 114, 138, 0.08);
    padding: 2px 6px;
    border-radius: 6px;
    line-height: 1.4;
}

.address {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .img {
        width: 11px;
        height: 6px;
    }
}

::v-deep .el-dialog {
    border-radius: 30px;
}

::v-deep .el-dialog__header {
    padding: 0;
}

::v-deep .el-dialog__body {
    padding: 30px;
}

.dialog_content {
    width: 100%;
    height: 326px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .form_item {
        margin-bottom: 24px;
    }

    .dialog_left {
        width: 49%;

        .left_title {
            font-weight: 500;
            font-size: 30px;
            color: #333333;
            text-align: center;
            margin-bottom: 34px;
        }
    }

    .dialog_right {
        width: 49%;
        background-color: #F7F9FA;
        border-radius: 18px;
        padding-top: 18px;

        .right_title {
            font-weight: 500;
            font-size: 24px;
            color: #666666;
            text-align: center;



        }
    }

    .submit {
        width: 174px;
        height: 40px;
        background-color: rgb(247, 249, 250);
        border: none;
        color: #999999;
        border-radius: 8px;
    }
}

</style>